/* Размер по флагу: `select.picker` (элемент + класс) обязателен — одноклассовый
   .picker проигрывает глобальному .select с width: 100%, и список растягивался
   на всю свободную ширину, схлопывая название приложения рядом. */
select.picker {
  flex: none;
  width: auto;
  min-width: 0;
  /* Ростом вровень с остальной полосой: флаг мельче текста кнопок, но
     собственная высота у него была бы вдвое меньше соседей. */
  height: var(--ctl-h);
  padding: 0 var(--sp-2);
  font-size: var(--fs-lg);
  line-height: 1;
  text-align: center;
  /* Без appearance: none нативная стрелка занимает больше места, чем сам флаг. */
  appearance: none;
  background-image: none;
  cursor: pointer;
}
